import type { InferContractRouterOutputs } from '@orpc/contract'
import { useQuery } from '@tanstack/react-query'
import type { BaseContract } from 'pixai-contract/api/orpc'
import { orpc } from './contract'

export type CampaignAdEntry =
  InferContractRouterOutputs<BaseContract>['campaignAds']['list']['data'][number]

interface UseCampaignAdsArgs {
  lang: string
  category?: string
}

/**
 * Pass `null` to skip the query (parity with the previous Apollo `skipToken`
 * call sites). When skipped, `data` is `undefined` and no request is fired.
 */
export function useCampaignAds(args: UseCampaignAdsArgs | null) {
  const enabled = args != null
  const { data, isLoading, error, refetch } = useQuery({
    ...orpc.campaignAds.list.queryOptions({
      input: {
        language: args?.lang,
        category: args?.category,
      },
    }),
    enabled,
  })
  return {
    data: data?.data,
    loading: isLoading,
    error,
    refetch,
  }
}
